<template>
  <button type="button" @click="openWhatsApp" class="inline-flex items-center px-3 py-2 text-sm font-medium text-center text-white bg-[#25D366] rounded-lg">
    <slot v-if="noText">
      <img src="@/assets/icons/whatsapp.svg" class="w-6 h-6" alt="WhatsApp Icon">
    </slot>
    <slot v-else>
      Back to WhatsApp
      <img src="@/assets/icons/whatsapp.svg" class="ml-4 w-6 h-6" alt="WhatsApp Icon">
    </slot>
  </button>
</template>

<script setup>
import { useAccountStore } from '@/stores/account';

import { computed } from 'vue';

const OpenWhatsAppUrl = computed(() => useAccountStore().OpenWhatsAppUrl);
const openWhatsApp = () => {
  window.open(OpenWhatsAppUrl.value, '_blank');
};

defineProps({
  noText: {
    default: false,
    type: Boolean,
  },
});
</script>
